import client from './client';

export interface SolarModule {
  id: number;brand: string;model: string;max_module_power: number;efficiency: number;temp_coeff: number;
  module_length: number;module_width: number;area: number;revision: number;usage_count: number;
}
export interface StringPanel {
  string_number: number;is_connected: boolean | null;solar_module_id: number | null;solar_module_quantity: number;
  installation_type: 'ROOF' | 'FREE_STANDING' | null;tracking_type: 'FIXED' | 'TRACKING' | null;
  slope: number | null;azimuth: number | null;vertical_axis_slope: number | null;inclined_axis_slope: number | null;
}
export interface PanelConfiguration {
  inverter: { id: number;name: string;plant_name: string;string_count: number | null };
  revision: number;rows: StringPanel[];
}
export interface PanelAudit {
  id: string;string_number: number | null;actor_name: string;changed_at: string;
  before_data: Record<string,unknown> | null;after_data: Record<string,unknown> | null;
}
export const panelError = (error: unknown) => {
  const result=error as { response?: { data?: { message?: string } } };
  return result.response?.data?.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.';
};
export async function fetchSolarModules(): Promise<SolarModule[]> {
  return (await client.get<SolarModule[]>('/solar-modules')).data.map(row=>({ ...row,
    ...Object.fromEntries(['max_module_power','efficiency','temp_coeff','module_length','module_width','area','usage_count'].map(key=>[key,Number(row[key as keyof SolarModule])])) }));
}
export async function saveSolarModule(module: Partial<SolarModule>) {
  if (module.id) await client.put(`/solar-modules/${module.id}`,module);
  else await client.post('/solar-modules',module);
}
export async function removeSolarModule(module: SolarModule) {
  await client.delete(`/solar-modules/${module.id}`,{ data: { revision:module.revision } });
}
export async function fetchPanelConfiguration(id: number): Promise<PanelConfiguration> {
  const data=(await client.get<PanelConfiguration>(`/inverters/${id}/panel-configuration`)).data;
  data.rows=data.rows.map(row=>({ ...row,...Object.fromEntries(['solar_module_quantity','slope','azimuth','vertical_axis_slope','inclined_axis_slope']
    .map(key=>[key,row[key as keyof StringPanel]==null ? null : Number(row[key as keyof StringPanel])])) }));
  return data;
}
export async function savePanelConfiguration(id: number,revision: number,changes: StringPanel[]) {
  await client.put(`/inverters/${id}/panel-configuration`,{ revision,changes });
}
export async function fetchPanelHistory(kind: 'module' | 'string',id: number,before?: string): Promise<{ rows: PanelAudit[];nextCursor: string | null }> {
  return (await client.get(kind==='module' ? `/solar-modules/${id}/history` : `/inverters/${id}/panel-configuration/history`,{ params:{ before } })).data;
}
